import { Box, Breadcrumbs, Grid, Link, makeStyles, styled, Typography as MuiTypography, Divider as MuiDivider, } from '@material-ui/core'
import PropertyForm from "./PropertyForm"
import { useSelector, useDispatch } from "react-redux";
import { AppStateType } from "../../../redux/reducers";
import { QuestionnaireContext, QuestionnaireContextProvider } from '../../../components/contexts/QuestionnaireContext';
import React, {FC, useContext, useEffect, useState} from "react";
import { NavLink, useParams, useRouteMatch } from 'react-router-dom';
import { spacing } from '@material-ui/system';
import { getURL, route, urls, useRouting } from '../../../routes';
import { useTranslation } from "react-i18next";
import {
    fetchProperty as propertyFetchProperty,
} from "../../../services/propertyService";
import * as types from "../../../constants";
import { AppDispatchType } from '../../../redux/store';
const Divider = styled(MuiDivider)(spacing);

const useStyles = makeStyles(theme => ({
    linkItem: {
        textDecoration: "none",
        color: "inherit",
        '&:hover': {
            textDecoration: "none!important"
        },
    },
    selected: {
        '&:hover': {
            textDecoration: "none!important"
        },
        '&.MuiLink-root': {
            textDecoration: "none",
            background: "linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)!important",
            "-webkit-background-clip": "text!important",
            "-webkit-text-fill-color": "transparent!important"
        },

    },
    title: {
        fontStyle: "normal", 
        fontWeight: 600, 
        fontSize: "20px", 
        lineHeight: "24px", 
        [theme.breakpoints.down("sm")]: {
            fontSize: "16px", 
        },
    }
}))

type MenuQuestionnairePropsType = {
    title?: string
}

export const MenuQuestionnaire: FC<MenuQuestionnairePropsType> = ({title = ''}) => {
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const { url } = useRouteMatch();
    const { id } = useParams<{ id: string }>();
    const styles = useStyles();
    const { t } = useTranslation();

    const urlDashboard = getURL(urls.dashboard);
    const urlQuestionnaire = getURL(urls.standards);
    const urlCreateNewProperty = getURL(urls.createNewProperty);
    const urlEditProperty = getURL(urls.editProperty, { id: property ? property.id : id });
    const urlSelectFacilities = getURL(urls.selectFacilities, { id: property ? property.id : id });
    const urlEditFacilities = getURL(urls.editFacilities, { id: property ? property.id : id });
    const urlClassify = getURL(urls.classify, { id: property ? property.id : id });

    if (url === urlQuestionnaire || url === urlCreateNewProperty) {
        return (
            <Box pb={4} className={`disable-scrolls`} overflow="scroll" id="app-header">
                <MuiTypography className={styles.title} variant="h3" gutterBottom display="inline">
                    {t("propertyListPage_propertyList")}
                </MuiTypography>
                <Breadcrumbs aria-label="Breadcrumb">
                    <Link component={NavLink} exact to={urlDashboard} className={`${url === '/' ? styles.selected : ""} ${styles.linkItem}`}>
                        {t("routes_Dashboard")}
                    </Link>
                    <Link component={NavLink} exact to={urlQuestionnaire} className={`${url === urlQuestionnaire ? styles.selected : ""} ${styles.linkItem}`}>
                        {t("routes_Questionnaire")}
                    </Link>
                    {url === urlCreateNewProperty ? <Link component={NavLink} exact to={urlCreateNewProperty} className={`${url === urlCreateNewProperty ? styles.selected : ""} ${styles.linkItem}`}>
                        {t("routes_NewProperty")}
                    </Link> : null}
                </Breadcrumbs>
                {url !== urlCreateNewProperty ? <Divider my={6} /> : null}
            </Box>
        )
    }
    return (
        <Box py={4} className={`disable-scrolls ${url.includes('classify') ? "overflowClassify" : ""}`} overflow="scroll" id="app-header">
            <MuiTypography className={styles.title} variant="h3" gutterBottom display="inline">
                {t("propertyListPage_propertyList")}<span style={{color: 'rgba(238, 238, 238, 0.5)'}}>{title ? ` (${title})` : null}</span>
            </MuiTypography>
            <Breadcrumbs aria-label="Breadcrumb">
                <Link component={NavLink} exact to={urlDashboard} className={`${url === '/' ? styles.selected : ""} ${styles.linkItem}`}>
                    {t("routes_Dashboard")}
                </Link>
                <Link component={NavLink} exact to={urlQuestionnaire} className={`${url === urlQuestionnaire ? styles.selected : ""} ${styles.linkItem}`}>
                    {t("routes_Questionnaire")}
                </Link>

                <Link component={NavLink} exact to={urlEditProperty} className={`${url === urlEditProperty ? styles.selected : ""} ${styles.linkItem}`}>
                    {t("routes_EditProperty")}
                </Link>
                <Link component={NavLink} exact to={urlSelectFacilities} className={`${url === urlSelectFacilities || url === urlEditFacilities ? styles.selected : ""} ${styles.linkItem}`}>
                    {t("routes_EditFacility")}
                </Link>
                <Link component={NavLink} exact to={urlClassify} className={`${url === urlClassify ? styles.selected : ""} ${styles.linkItem}`}>
                    {t("questionnaire")}
                </Link>
            </Breadcrumbs>
            {url === urlQuestionnaire ? <Divider my={6} /> : null}

        </Box>
    )
}
export default function EditProperty() {
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const dispatch = useDispatch();
    const { id } = useParams<{ id: string }>();
    const { routeTo } = useRouting();
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    useEffect(() => {
        if (!property && id) {
            dispatch(async (dispatch: AppDispatchType) => {
                return propertyFetchProperty(id, user.token)
                    .then((response: any) => {
                        dispatch({
                            type: types.FETCH_PROPERTY,
                            property: response.data,
                        });
                    }).catch(err => routeTo(urls.notFound))
            });
        }
    }, [])
    if (!property) {
        return <div></div>
    }
    return (
        <Box p={12} width="100%">
            <MenuQuestionnaire />
            <Grid container style={{ justifyContent: 'center'}} >
                <Grid item xs={12}>
                    <PropertyForm addMode={true} />
                </Grid>
            </Grid>
        </Box>
    )
}
